import { useEffect, useMemo, useState, type ReactNode } from "react";
import { AuthStateContext, type AuthState } from "./AuthContext";
import { subscribeAuth } from "./firebaseAuth";

export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>({ status: "loading" });

  useEffect(() => {
    const unsubscribe = subscribeAuth((user) => {
      if (user) {
        setState({ status: "authenticated", user });
      } else {
        setState({ status: "unauthenticated" });
      }
    });
    return unsubscribe;
  }, []);

  const value = useMemo(() => state, [state]);
  return <AuthStateContext.Provider value={value}>{children}</AuthStateContext.Provider>;
}
